// KebabMenu.jsx
import React, { useRef, useState } from 'react';
import { Overlay } from 'react-bootstrap';
import dotsThreeIcon from '../../../../assets/img/DotsThree.svg';
import style from '../Milestone/Milestone.module.css';
import copylink from '../../../../assets/img/copylink.svg';
import duplicate from '../../../../assets/img/duplicate.svg';
import cross3 from '../../../../assets/img/cross3.svg';
import uncheckIcon from '../../../../assets/img/uncheckicon.svg';
import checkIcon from '../../../../assets/img/checkgreen.svg';
import deleteIcon from '../../../../assets/img/deletlisticon.svg';
import archieveIcon from '../../../../assets/img/archieve-milestone.svg';
import plusIcon from 'assets/img/add-circle.svg';
import rightIcon from 'assets/img/rightcheck.svg';

export default function KebabMenu({
  onClone,
  onDelete,
  onCopy,
  onArchieve,
  hideClone = false,
  isArchived,
  isSubtask = false,
  showAddSubtask,
  handleCompleteSubtask,
  isCompletedtask,
  handleCompletetask
}) {
  const [show, setShow] = useState(false);
  const tgtRef = useRef(null);

  return (
    <div className={style.custom_drp}>
      {!isCompletedtask ? (
        <>
          <img
            className={style.opacity1}
            src={uncheckIcon}
            onClick={(e) => {
              e.stopPropagation();
              if (isSubtask) {
                e.stopPropagation();
                handleCompleteSubtask();
              } else {
                e.stopPropagation();
                handleCompletetask();
              }
            }}
            alt="complete-icon"
          />
          {!isSubtask && (
            <img
              src={plusIcon}
              onClick={(e) => {
                e.stopPropagation();
                showAddSubtask();
              }}
              alt="clock-icon"
            />
          )}
        </>
      ) : (
        <>
          <img
            className={style.opacity1}
            src={checkIcon}
            onClick={(e) => {
              e.stopPropagation();
              if (isSubtask) {
                e.stopPropagation();
                handleCompleteSubtask();
              } else {
                e.stopPropagation();
                handleCompletetask();
              }
            }}
            alt="complete-icon"
          />
          {!isSubtask && (
            <img
              src={plusIcon}
              onClick={(e) => {
                e.stopPropagation();
                showAddSubtask();
              }}
              alt="clock-icon"
            />
          )}
        </>
      )}

      <div
        ref={tgtRef}
        style={{ cursor: 'pointer', marginTop: '-2px' }}
        onClick={(e) => {
          e.stopPropagation();
          setShow((s) => !s);
        }}>
        <img src={dotsThreeIcon} alt="menu" />
      </div>

      <Overlay
        show={show}
        target={tgtRef.current}
        placement="bottom-end"
        container={document.body} // ⬅️ portal to body
        rootClose
        onHide={() => setShow(false)}
        flip>
        {({ ...props }) => (
          <div
            {...props}
            className={`${style.dropdown_menu} ${style.kebab_menu}`}
            onClick={(e) => e.stopPropagation()}
            style={{
              ...props.style,
              position: 'fixed', // ⬅️ not affected by scroll container
              zIndex: 2000
            }}>
            <div
              className={style.menuItem}
              onClick={() => {
                onCopy();
                setShow(false);
              }}>
              <img src={copylink} alt="copylink" className="featherdrowpdown-icon" />
              Copy Link
            </div>
            {!hideClone && (
              <div
                className={style.menuItem}
                onClick={() => {
                  onClone();
                  setShow(false);
                }}>
                <img src={duplicate} alt="duplicate" className="featherdrowpdown-icon" />
                Duplicate
              </div>
            )}

            <div
              className={style.menuItem}
              onClick={() => {
                onDelete();
                setShow(false);
              }}>
              <img src={deleteIcon} alt="cross3" className="featherdrowpdown-icon" />
              Delete
            </div>
             {!isSubtask && <div
              className={style.menuItem}
              onClick={() => {
                onArchieve();
                setShow(false);
              }}>
              <img src={archieveIcon} alt="cross3" className="featherdrowpdown-icon" />
              {isArchived ? 'Unarchive' : 'Archive'}
            </div>}
          </div>
        )}
      </Overlay>
    </div>
  );
}
